import React from 'react';
import { Helmet } from 'react-helmet-async';
import queryString from 'query-string';
import Redirect from '@/components/Redirect';
import { useUser } from '@lore/auth';
import PageHeader from '@/pages/people-people/PageHeader';

export default function Layout() {
  const currentUser = useUser();

  return (
    <div className="p-8 space-y-8">
      <Helmet>
        <title>Explore active projects and events</title>
      </Helmet>
      <PageHeader
        title="Explore active projects and events"
        subtitle={(
          <>
            Check out inspiring projects and events where educators and learners are looking
            for partners. See how you can connect and contribute your skills and experiences to
            make a difference. Use filters to find projects and events that interest you.
          </>
        )}
      />
      <Redirect
        to={{
          pathname: '/projects-events',
          search: queryString.stringify({
            locationCondition: JSON.stringify({
              address: currentUser.data.zipCode,
              latitude: currentUser.data.latitude,
              longitude: currentUser.data.longitude,
              radius: 50
            })
          })
        }}
        replace={true}
      />
    </div>
  );
}
